module.exports = __webpack_public_path__ + "img/20190807162114464.bd232fc6.png";